<template>
  <div id="header">
    <section class="hero" :class="heroHeight()" :style="heroBackground()">
      <div class="hero-head">
        <nav class="navbar is-fixed-top" :class="$route.name" v-scroll="handleScroll">
          <div class="navbar-brand">
            <router-link class="navbar-item" :to="{ name: 'home' }">
              <img id="logo" :src="logoDisplay()" alt="Logo">
            </router-link>
            <span class="navbar-burger burger" @click="bugerOpenClose()">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
          <div id="navbarMenuHeroB" class="navbar-menu">
            <div class="navbar-end">
              <router-link class="navbar-item" :to="{ name: 'home' }">
                <span @click="bugerOpenClose()">Accueil</span></router-link>
              <router-link class="navbar-item" :to="{ name: 'office' }">
                <span @click="bugerOpenClose()">Notre organisation</span></router-link>
              <router-link class="navbar-item" :to="{ name: 'trades' }">
                <span @click="bugerOpenClose()">Notre métier</span></router-link>
              <b-dropdown class="navbar-item"
              :class="$route.name === 'services'  ? 'is-active': ''">
                <a class="navbar-item" slot="trigger">
                  <span class="service">Services</span>
                  <b-icon icon="menu-down"></b-icon>
                </a>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/transport">
                    <span @click="bugerOpenClose()">Flotte &amp; Transport</span>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/entreprises">
                    <span @click="bugerOpenClose()">Entreprises &amp; Industries</span>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/franchises">
                    <span @click="bugerOpenClose()">Franchisés</span>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/construction">
                    <span @click="bugerOpenClose()">Construction</span>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/assurances-personnes">
                    <span @click="bugerOpenClose()">Assurances de personnes</span>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <router-link to="/nos-services/assurances-particuliers">
                    <span @click="bugerOpenClose()">Assurances du particulier</span>
                  </router-link>
                </b-dropdown-item>
              </b-dropdown>
              <router-link class="navbar-item" :to="{ name: 'news' }">
                <span @click="bugerOpenClose()">Actualités</span></router-link>
              <router-link class="navbar-item" :to="{ name: 'join' }">
                <span @click="bugerOpenClose()">Nous rejoindre</span></router-link>
              <router-link class="navbar-item" :to="{ name: 'contact' }">
                <span @click="bugerOpenClose()">Contact</span></router-link>
              <b-dropdown class="navbar-item" position="is-bottom-left">
                <a class="navbar-item" slot="trigger">
                  <span><img class="account" src="@/assets/icons/profile_bold.svg"> Espace client</span>
                  <b-icon icon="menu-down"></b-icon>
                </a>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <a target="_blank" href="http://extranet.cabinet-guemas.fr/Services/Login.aspx">
                    <span @click="bugerOpenClose()">Espace client actuel</span>
                  </a>
                </b-dropdown-item>
                <b-dropdown-item @click="dropdownOpenClose()">
                  <a target="_blank" href="https://espace-client.guemas-associes.fr/">
                    <span @click="bugerOpenClose()">Nouvel extranet client</span>
                  </a>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </nav>
      </div>

      <div class="hero-body home" v-if="$route.name === 'home'">
        <figure class="column is-8 is-m-auto has-text-centered">
          <img class="logo" src="@/assets/images/home/hero.svg" alt="">
        </figure>
      </div>
      <div v-else-if="$route.name !== 'contact'
      && $route.name !== 'news'
      && $route.name !== 'legal-notices'
      && $route.name !== 'profil'">
        <div class="hero-body page">
          <div class="rectangle is-uppercase" :class="[$route.name, $route.params.id]">
            <h1 v-if="$route.name === 'office'" class="title">Notre organisation</h1>
            <h1 v-if="$route.name === 'trades'" class="title">Notre métier</h1>
            <h1 v-if="$route.name.includes('services')" class="title">Nos services</h1>
            <h1 v-if="$route.name === 'join'" class="title join">Nous rejoindre</h1>
            <h1 v-if="$route.name === 'article'" class="title join">Actualités</h1>
            <figure class="image is-3by1"></figure>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as headers from '@/assets/images/headers';
import * as logos from '@/assets/logos';

export default {
  name: 'layout-header',
  props: ['page'],
  directives: {
    scroll: {
      inserted(el, binding) {
        const f = ((event) => {
          if (binding.value(event, el)) {
            window.removeEventListener('scroll', f);
          }
        });
        window.addEventListener('scroll', f);
      },
    },
  },
  methods: {
    bugerOpenClose() {
      const classes = document.getElementById('navbarMenuHeroB').classList;
      const response = !this.$lodash.includes(classes, 'is-active') ? classes.add('is-active') : classes.remove('is-active');
      return response;
    },
    dropdownOpenClose() {
      document.getElementsByClassName('dropdown-menu').hidden = true;
    },
    heroHeight() {
      const response = ({
        home: 'is-medium',
        office: 'is-medium',
        trades: 'is-medium',
        services: 'is-medium',
        join: 'is-medium',
        contact: 'is-small',
        news: 'is-small',
        'legal-notices': 'is-small',
      })[this.$route.name];
      return response;
    },
    heroBackground() {
      const image = this.page ? this.page.document.bannerImage.url : headers.home;
      return { backgroundImage: `url(${image})` };
    },
    logoDisplay() {
      const pageName = this.$route.name;
      const response = pageName === 'contact' || pageName === 'news' || pageName === 'legal-notices' || pageName === 'profil' ? logos.logoHMulti : logos.logoHMono;
      return response;
    },
    handleScroll() {
      if (window.scrollY !== 0) {
        document.querySelector('.navbar').setAttribute('style', 'background-color: rgba(3, 45, 86, 0.9); transition: background-color 0.5s ease-in-out');
        if (document.querySelector('.navbar.contact')
        || document.querySelector('.navbar.legal-notices')
        || document.querySelector('.navbar.news')
        || document.querySelector('.navbar.profil')) {
          document.getElementById('logo').setAttribute('src', logos.logoHMono);
          document.querySelectorAll('.navbar .navbar-end a').forEach((element) => {
            if (!this.$lodash.includes(element.classList, 'dropdown-item')) {
              element.classList.add('has-text-white');
            }
          });
        }
      } else {
        document.querySelector('.navbar').setAttribute('style', 'background-color: transparent; transition: background-color 0.5s ease-in-out');
        if (document.querySelector('.navbar.contact')
        || document.querySelector('.navbar.legal-notices')
        || document.querySelector('.navbar.news')
        || document.querySelector('.navbar.profil')) {
          document.getElementById('logo').setAttribute('src', logos.logoHMulti);
          document.querySelectorAll('.navbar .navbar-end a').forEach((element) => {
            if (!this.$lodash.includes(element.classList, 'dropdown-item')) {
              element.classList.remove('has-text-white');
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="sass">
  #header
    .hero
      background-color: #032f56
      background-size: cover
      nav.navbar
        a
          color: #ffffff
          line-height: 1
          .account
            margin-right: 2px
            width: 16px
            vertical-align: -4px
        #logo
          margin-top: 0.2rem
        .burger
          color: #ffffff
        &.contact a, &.legal-notices a, &.news a, &.profil a
          color: #0e6faa
        .navbar-menu
          .navbar-end
            span.service
              padding-right: 0 !important
            > a:first-child
              padding: 0 0.6rem
            .navbar-item
              padding: 0
              text-transform: uppercase
              &~.navbar-item span:first-child
                padding: 0 0.6rem
                border-left: 1px solid #ffffff
              &:hover
                background-color: transparent
              &:first-child::after
                margin: 0.7rem 0
            > a.navbar-item:first-child
              padding-right: 0.6rem
            > a.router-link-active, .is-active
                &::after
                  position: absolute
                  content: ""
                  margin: 0.7rem 0
                  height: 2px
                  width: 1.5rem
                  bottom: 0
                  background-color: #fe3904
                  margin-left: 0.7rem
            .router-link-active, .dropdown.is-active .dropdown-trigger
              span
                color: #fe3904 !important
          .dropdown
            .dropdown-content
              .dropdown-item
                padding: 0 !important
                span
                  color: #0e6faa
                  margin-left: 1.5rem
              a
                position: relative
                display: inline-block
                padding: 0.5rem 2rem 0.5rem 0
                width: 100%
                .router-link-active::after
                  position: absolute
                  content: ""
                  margin: 0
                  height: 2px
                  width: 1.5rem
                  top: 45%
                  left: 0
                  background-color: #fe3904
    .hero-body.home
      display: flex
      align-items: center
      height: 100vh
      .logo
        width: 700px
        margin-bottom: -50px
    .hero-body.page
      padding-left: 10%
      h1
        position: relative
        font-size: 2rem
        font-weight: 500
        color: #ffffff !important
        z-index: 1
      figure
        margin: 1rem 0 0 0
        padding: 0
        height: 6px
        width: 10%
        background-color: #fe3904
        z-index: 1
      .rectangle
        position: relative
        margin: 1.5rem 0 0 0
        padding: 3rem 0
        &::after
          position: absolute
          content: ""
          height: 100%
          width: 50%
          top: 0
          left: -20%
          background-color: rgba(3, 45, 86, 0.85)
          z-index: 0
        &.office::after
          width: 45%
        &.trades::after
          width: 50%
        &.services::after
          width: 55%
        &.join::after
          width: 63%

  @media screen and (max-width: 1024px)
    #header
      .hero
        .navbar-menu a
          margin: 1rem 0
          color: #0e6faa !important
      .hero-body.page
        h1
          font-size: 2rem
    #header .hero nav.navbar .navbar-menu .navbar-end > a.router-link-active::after,
    #header .hero nav.navbar .navbar-menu .navbar-end .is-active::after
      display: none
</style>
